export default __webpack_public_path__ + "static/media/33.c24e6099.png";